import { render, staticRenderFns } from "./InformacionPersonal.vue?vue&type=template&id=329a1775"
import script from "./InformacionPersonal.vue?vue&type=script&lang=js"
export * from "./InformacionPersonal.vue?vue&type=script&lang=js"
import style0 from "./InformacionPersonal.vue?vue&type=style&index=0&id=329a1775&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports